/**
 * Slugifies an image name or repository name according to ABC standards:
 * - trim, lowercase
 * - normalize Vietnamese diacritics to Latin characters
 * - replace invalid characters and separators with hyphen (-)
 * - collapse multiple consecutive hyphens into one
 * - strip leading and trailing hyphens
 */
export function slugifyImageName(input: string): string {
  if (!input || typeof input !== 'string') return '';

  return (
    input
      .trim()
      // Normalize Vietnamese accents using Unicode NFD and remove diacritics
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      // Handle special Vietnamese letters like đ/Đ
      .replace(/[đĐ]/g, 'd')
      .toLowerCase()
      // Replace non-alphanumeric chars (except hyphens and underscores) with hyphens
      .replace(/[^a-z0-9_-]/g, '-')
      // Replace underscores with hyphens
      .replace(/_/g, '-')
      // Collapse multiple consecutive hyphens into one
      .replace(/-+/g, '-')
      // Strip leading and trailing hyphens
      .replace(/^-+|-+$/g, '')
  );
}
